var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-dialog',{staticClass:"export-dialog",attrs:{"visible":_vm.visible,"width":600,"handle-close":_vm.handleClose,"title":_vm.title,"closeText":_vm.$t('language.5o6uut7rgac0'),"showFt":false}},[_c('div',{staticClass:"content-wrapper"},[_vm._v("\n    "+_vm._s(this.content)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }